import type { XYCoord } from 'react-dnd';

import { OFFSET_FROM_CURSOR_IN_PX } from '../const';

export const getTransform = (clientOffset: XYCoord) =>
  `translate(${clientOffset.x - OFFSET_FROM_CURSOR_IN_PX}px, ${
    clientOffset.y + OFFSET_FROM_CURSOR_IN_PX
  }px)`;
